import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Field, useBusy } from "../components/common";
import { AuthShell } from "./ForgotPassword";

export default function ResetPassword({ endpoint = "/auth/reset-password" }) {
  const { token } = useParams();
  const { t } = useLang();
  const [pw, setPw] = useState({ new_password: "", confirm: "" });
  const [done, setDone] = useState(false);
  const [busy, run] = useBusy();
  const submit = (e) =>
    run(async () => {
      e.preventDefault();
      if (pw.new_password !== pw.confirm) return toast.error(t("Passwords do not match", "Las contraseñas no coinciden"));
      try {
        await api.post(endpoint, { token, new_password: pw.new_password });
        setDone(true);
      } catch (err) {
        toast.error(errMsg(err));
      }
    });
  return (
    <AuthShell testid="reset-password-page">
      <h1 className="text-3xl font-extrabold text-slate-900">{t("Create a new password", "Crea una nueva contraseña")}</h1>
      {done ? (
        <p className="mt-4 p-4 rounded-xl bg-emerald-50 text-emerald-800" data-testid="reset-password-done">
          {t("Your password was changed. You can sign in now.", "Su contraseña fue cambiada. Ya puede iniciar sesión.")}
        </p>
      ) : (
        <form onSubmit={submit} className="mt-6 grid gap-4">
          <Field label={t("New password (min 8)", "Nueva contraseña (mín 8)")}><input className="inp" type="password" required minLength={8} autoComplete="new-password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="reset-new-password" /></Field>
          <Field label={t("Confirm new password", "Confirmar nueva contraseña")}><input className="inp" type="password" required minLength={8} autoComplete="new-password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} data-testid="reset-confirm-password" /></Field>
          <button className="btn-primary h-14 text-base" disabled={busy} data-testid="reset-submit-btn">{t("Save new password", "Guardar nueva contraseña")}</button>
        </form>
      )}
      <Link to="/login" className="mt-6 text-sm font-semibold text-[#D9531E]" data-testid="reset-back-to-login">{t("Back to sign in", "Volver a iniciar sesión")}</Link>
    </AuthShell>
  );
}
